
<b-row class="proprietes-jeu mx-0" :class="{ 'jeu-ced mr-xl-3 mt-xl-0 mb-xl-3': idFamille }">
  <b-col
    class="d-flex text-center mt-1 mt-md-0 px-md-4 overflow-auto"
    order-md="2"
    cols="12"
    :class="$mq == 'xs' ? 'info-mobile' : 'info px-2'"
  >
    <div class="bloc-info">
      <div class="titre-info">{{ $t('messageComponent.miseMin') }}</div>
      <div>
        {{ getFormatMontant(produit.betLimits ? produit.betLimits.CAD.min : produit.miseMin) }}
      </div>
    </div>
    <div class="bloc-info">
      <div class="titre-info">{{ $t('messageComponent.miseMax') }}</div>
      <div>
        {{ getFormatMontant(produit.betLimits ? produit.betLimits.CAD.max : produit.miseMax) }}
      </div>
    </div>
    <div v-if="produit.nbLigne > 0" class="bloc-info">
      <div class="titre-info">{{ $t('messageComponent.lignes') }}</div>
      <div>{{ produit.nbLigne }}</div>
    </div>
    <div v-if="produit.mntGrosLot" class="bloc-info">
      <div class="titre-info">{{ $t('messageComponent.gainMaximum') }}</div>
      <div>{{ getFormatMontant(produit.mntGrosLot) }}</div>
    </div>
    <div v-if="produit.dealer" class="bloc-info">
      <div class="titre-info">{{ $t('messageComponent.presentateur') }}</div>
      <div>{{ produit.dealer.name }}</div>
    </div>
    <div v-if="langueI18n" class="bloc-info">
      <div class="titre-info">{{ $tc('langue', langue == 'fren' ? 2 : 1) }}</div>
      <div class="text-uppercase">{{ langueI18n }}</div>
    </div>
  </b-col>
  <b-col
    class="titreJeu graphik_black mb-2 mb-md-1 mt-md-3 px-2 px-md-4"
    order-md="1"
    cols="12"
    v-html="mixinProduitCasino_getTitre()"
  />
  <b-col
    v-if="produit.titreMarketing"
    class="titre-marketing graphik_black col-12 col-md-7 mb-2 mt-md-2 mb-md-3 px-2 px-md-4"
    order-md="3"
    v-html="produit.titreMarketing"
  />
  <b-col
    v-if="produit.description"
    class="col-12 col-md-7 px-2 px-md-4"
    :class="{ 'col-md-7': idFamille }"
    order-md="3"
  >
    <div class="description texteListe mb-2" v-html="contentDescription"></div>
    <div
      v-if="produit.description.length > 270"
      class="plus graphik_medium mb-3 mb-md-0"
      @click="descriptionOuvert = !descriptionOuvert"
    >
      {{
        descriptionOuvert
          ? $t('messageComponent.enSavoirMoins')
          : $t('messageComponent.enSavoirPlus')
      }}
    </div>
  </b-col>
  <b-col
    v-if="listeEtiquette.length > 0"
    class="col-12 px-0 px-md-4"
    :class="{ 'col-md-5': produit.description }"
    order-md="5"
  >
    <div class="caracteristiques px-2">
      {{ $t('messageComponent.caracteristiques') }}
    </div>
    <div class="liste-boutons-collections d-flex overflow-auto py-1 px-2 pl-1">
      <b-button
        v-for="etiquette in listeEtiquette"
        :key="etiquette['@id']"
        pill
        class="mb-1 mr-1 px-2 py-1"
        v-bind="jel_getLienBinding(getLienCollection(etiquette))"
      >
        {{ etiquette.titre }}
      </b-button>
    </div>
  </b-col>
</b-row>
